<template>
  <div>
  <b-card v-if="isNotEmpty" class="no-border">
    <b-form>
      <div class="pull-right form-group">
        <b-button v-show="shipmentDetaildata.state == 'CREATED'" @click="addOrder()" variant="success">Add order &nbsp;<i class="fa fa-plus"></i></b-button>
      </div>
    </b-form>
    <b-table striped responsive
    :items="(isFetched ? table.items : dataBeforeLoad)"
    :fields="table.fields"
    :class="isLoading ? 'show__blur' : ''">
      <template #cell(number)="data">
        <span @click="goToOrderDetail(data.item.id)" class="link__order">{{data.value}}</span>
      </template>
      <template #cell(customer)="data">
        <div v-if="data.value">
          <div>{{data.value.name}}</div>
          <template v-if="data.value.address">
            <div class="small text-muted">{{data.value.address.address1}}</div>
            <div class="small text-muted">{{data.value.address.city}} {{data.value.address.state}} {{data.value.address.zip_code}}</div>
            <div v-if="!data.item.destination" class="text-danger small">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
 Invalid destination</div>
          </template>
        </div>
      </template>
      <template #cell(location)="data">
        <div v-if="data.item.destination">
          <div>{{data.item.destination.code}}</div>
          <div class="small">{{data.item.destination.name}}</div>
        </div>
      </template>
      <template #cell(created_at)="data">{{formatDateTime(data.value)}}</template>
      <template #cell(time_in)="data">
        <div v-b-tooltip.hover title="Time In GPS" class="text-muted small">
          <i class="fa fa-truck"></i>
          {{formatDateTime(getTimeIn(data.item.metadata)) || 'Unknown'}}
        </div>
        <div v-if="!isCopp" v-b-tooltip.hover title="Time In App" class="text-muted small">
          <i class="fa fa-android"></i>
          {{formatDateTime(getTimeIn(data.item.metadata, 'app')) || 'Unknown'}}
        </div>
      </template>
      <template #cell(time_out)="data">
        <div v-b-tooltip.hover title="Time Out GPS" class="text-muted small">
          <i class="fa fa-truck"></i>
          {{formatDateTime(getTimeOut(data.item.metadata)) || 'Unknown'}}
        </div>
        <div v-if="!isCopp" v-b-tooltip.hover title="Time Out App" class="text-muted small">
          <i class="fa fa-android"></i>
          {{formatDateTime(getTimeOut(data.item.metadata, 'app')) || 'Unknown'}}
        </div>
      </template>
      <template #cell(duration)="data">
        <div v-if="getDuration(data.item.metadata)" v-b-tooltip.hover title="Duration GPS" class="text-muted small">
          <i class="fa fa-truck"></i>
          {{getDuration(data.item.metadata)}}
        </div>
        <div v-if="getDuration(data.item.metadata, 'app')" v-b-tooltip.hover title="Duration App" class="text-muted small">
          <i class="fa fa-android"></i>
          {{getDuration(data.item.metadata, 'app')}}
        </div>
      </template>
      <template #cell(confirmed_by)="data">
        <div v-if="!isObjectEmpty(getConfirmation(data.item))">
          <div class="text-success"><i class="fa fa-user" aria-hidden="true"></i>
            {{getConfirmation(data.item).name}}
          </div>
          <div class="text-muted small"><i class="fa fa-calendar" aria-hidden="true"></i>
            {{formatDateTime(getConfirmation(data.item).created_at)}}
          </div>
        </div>
        <div v-else class="text-muted">Unconfirmed</div>
      </template>
      <template #cell(signature)="data">
        <img class="table-confirm-signature"
          v-if="!isObjectEmpty(getConfirmation(data.item)) && checkHasSignature(data.item)"
          :src="createSignature(getConfirmation(data.item).signature)"
          alt="signature">
      </template>
      <template #cell(notes)="data">
        <span v-if="!isObjectEmpty(getConfirmation(data.item))">
          <span v-if="getConfirmation(data.item).metadata.remark">
            {{ getConfirmation(data.item).metadata.remark }}
            <span v-if="getConfirmation(data.item).metadata.notes">-</span>
          </span>
          <span>
            {{ getConfirmation(data.item).metadata.notes }}
          </span>
        </span>
        <span v-if="isAbort(data.item)" class="text-danger">
          {{data.item.metadata.abort.reason}}
        </span>
        <span v-if="get(data, 'item.metadata') && get(data, 'item.metadata.status')" class="text-info">
          {{data.item.metadata.status.status}}
        </span>
        <span v-if="get(data, 'item.metadata.rejected')" class="text-danger">
            <div class="text-muted"><i class="fa fa-user" aria-hidden="true"></i>
              {{get(data, 'item.metadata.rejected.name')}}
            </div>
            {{get(data, 'item.metadata.rejected.reason')}}
          </span>
      </template>
      <template #cell(info)="data">
        <span v-if="isAbort(data.item)" class="text-danger">
          {{data.item.metadata.abort.reason}}
        </span>
        <span v-else-if="get(data, 'item.metadata.rejected')" class="text-danger">
          <div class="text-muted"><i class="fa fa-user" aria-hidden="true"></i>
            {{get(data, 'item.metadata.rejected.name')}}
          </div>
          {{get(data, 'item.metadata.rejected.reason')}}
        </span>
        <span v-else-if="!isObjectEmpty(getConfirmation(data.item))">
          {{ getConfirmation(data.item).metadata.notes }}
        </span>
      </template>
    </b-table>
    <div
      class="show__loading"
      v-if="isLoading"
      :style="`height: ${dataBeforeLoad.length*75+70}px;`">
      <center>
      <i
        class="fa fa-spinner fa-pulse fa-4x fa-modify"
        alt="Loading"
        :style="`margin-bottom: ${(dataBeforeLoad.length*75+50)/2}px;`"></i>
      </center>
    </div>
  </b-card>
  <!-- <b-alert show v-if="table.items.length === 0" style="bottom:50px">There's no orders available.</b-alert> -->
  <b-alert show v-if="isFetched && table.items.length === 0" class="alert">There's no data available.</b-alert>

  </div>
</template>
<script>
import dateMixin from '@/mixins/date';
import { sortBy, isEmpty, isObject, cloneDeep } from 'lodash';
import get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import { loadShipmentOrders } from './useShipmentDetail';

export default {
  name: 'shipment_order_list',
  mixins: [dateMixin],
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      loaded: false,
      searchQuery: '',
      filterType: 'ACTIVE',
      table: {
        fields: [
          'number',
          'customer',
          'created_at',
          'time_in',
          'time_out',
          'duration',
          'confirmed_by',
          'signature',
          'notes',
        ],
        items: [],
      },
      sortType: null,
      dataBeforeLoad: [],
      orders: [],
      section: routes[4] || '',
    };
  },
  created() {
    if (this.isCopp) {
      this.table.fields = [
        'number',
        'location',
        'created_at',
        'time_in',
        'time_out',
        'duration',
        'confirmed_by',
        'info',
      ];
    }
    const { shipmentId } = this.$route.params;
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'shipments', name: 'Shipments' },
      { to: shipmentId, name: 'Detail' },
    ]);
    const { token } = this.$store.getters;
    try {
      loadShipmentOrders(token, shipmentId).then((orders) => {
        this.loaded = true;
        const sortedOrders = sortBy(orders, o => o.sequence);
        this.orders = sortedOrders;
      });
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    shipmentDetaildata() {
      return this.$store.getters['shipment_md/shipments/get_detail_data'];
    },
    isCopp() {
      return this.$store.getters.isCopp;
    },
    isNotEmpty() {
      return true;
    },
    isLoading() {
      return !this.loaded;
    },
    isFetched() {
      return this.loaded;
    },
  },
  watch: {
    orders(data) {
      this.table.items.splice(0);
      // data.sort((a, b) => (a.sequence > b.sequence ? -1 : 1));
      data.forEach((d) => {
        this.table.items.push(d);
      });
    },
    section(newSection) {
      const { shipmentId } = this.$route.params;
      this.$router.push(`/shipment_md/shipments/${shipmentId}/${newSection}`);
    },
  },
  methods: {
    get,
    getDuration(metadata, source = 'gps') {
      const timeIn = this.getTimeIn(metadata, source);
      const timeOut = this.getTimeOut(metadata, source);
      const durationInMinutes = this.getDurationValueInMinutes(timeOut, timeIn);

      const minutesInADay = 1440;
      const isMoreThanOneDay = durationInMinutes > minutesInADay;
      const durationHumanize = isMoreThanOneDay ? 'more than 1day' : `${durationInMinutes} minutes`;

      return durationInMinutes > 0 ? durationHumanize : undefined;
    },
    loadData() {
      this.dataBeforeLoad = cloneDeep(this.table.items);
    },
    addOrder() {
      const { company } = this.shipmentDetaildata;
      const shipment = { ...this.shipmentDetaildata };
      this.$store.commit('shipment_md/orders/SET_SELECTED_VALUE', {
        company,
        shipment,
      });
      this.$router.push('/shipment_md/orders/create');
    },
    getConfirmation(data) {
      return data.confirmations.find(c => c.key === 'customer') || {};
    },
    checkHasSignature(data) {
      const comfirmation = this.getConfirmation(data);
      const hasSignature = !isEmpty(comfirmation.signature);
      return hasSignature;
    },
    isObjectEmpty(object) {
      return isEmpty(object);
    },
    getTimeIn(metadata, source = 'gps') {
      if (isObject(metadata)) {
        const sourceKey = source === 'gps' ? 'time_in' : 'time_in_app';
        return metadata[sourceKey] || '-';
      }
      return undefined;
    },
    getTimeOut(metadata, source = 'gps') {
      if (isObject(metadata)) {
        const sourceKey = source === 'gps' ? 'time_out' : 'time_out_app';
        return metadata[sourceKey] || '-';
      }
      return undefined;
    },
    createSignature(data) {
      return `data:image/png;base64,${data}`;
    },
    goToOrderDetail(orderId) {
      const { shipmentId } = this.$route.params;
      this.$router.push({
        name: 'Order Detail',
        params: {
          shipmentId,
          orderId,
        },
      });
    },
    isAbort(data) {
      if (!isUndefined(data.metadata) && !isNull(data.metadata)) {
        const abort = get(data, 'metadata.abort', false);
        return abort;
      }
      return false;
    },
  },
};
</script>
<style lang="sass">
.show__loading
  height: 800px
  width: 96.5%
  position: absolute
  opacity: 0.3
  background-color: #9E9E9E
  bottom: -30px

.table-confirm-signature
  height: 80px
  margin: -0.5rem

.alert
  bottom: 50px
  width: 96.5%
  left: 20px
  text-align: center

.link__order
  color: #20a8d8;
  cursor: pointer;

.link__order:hover
  color: #167495;
  text-decoration: underline;

.show__blur
  -webkit-filter: blur(1px)
  -moz-filter: blur(1px)
  -ms-filter: blur(1px)
  -o-filter: blur(1px)
  filter: blur(1px)
</style>




// WEBPACK FOOTER //
// src/views/pages/shipment_md/shipments/detail/Orders.vue